import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import i18next from "../../utils/lang/i18n";
import AuthenticationService from "./AuthenticationService.js";
import { GetLoggedInUserName } from "../../services/commonService.js";

// MUI
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CheckBox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// ICON
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";

import icon_ID from "../../assets/images/icon/login_id.png";
import icon_PW from "../../assets/images/icon/login_pw.png";

import { amber, orange } from "@mui/material/colors";
import { styled, createTheme } from "@mui/material/styles";
import { withStyles } from "@material-ui/core/styles";
import { API } from "../../config";
import { getAPI} from "../../services/commonService";

// IMG
import login_BG from "../../assets/images/bg/login_bg.png";
import logo_black from "../../assets/images/logo/ezcams_black.png";

// [공통] 버튼
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(orange[800]),
  backgroundColor: "#8D7C57",
  "&:hover": {
    backgroundColor: "#CEAE6A",
  },
}));

const theme = createTheme({
  palette: {
    secondary: {
      main: "#78909c",
      contrastText: "#ffffff",
    },
  },
});

const styles = {
  container: {
    backgroundImage: `url(${login_BG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styless = (theme) => ({
  textBox: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px 6px 0 0",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#CEAE6A",
    },
  },
  textBox2: {
    "& .MuiOutlinedInput-root": {
      border: "none",
      borderRadius: "0 0 6px 6px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#CEAE6A",
    },
  },
});

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      store: [],
      branch: "",
      username: localStorage.getItem("authenticatedUser") || "",
      password: "",
      token: localStorage.getItem("token") || "",
      hasLoginFailed: false,
      showSuccessMessage: false,
      lang: "",
      isDialogOpen: false, // 인증서 다운로드 모달 상태
      showInstallGuide: false, // 인증서 설치 방법 모달 상태
      isTokenExpired: false, // 토큰 만료 메시지 상태
    };

    this.handleChange = this.handleChange.bind(this);
    this.loginClicked = this.loginClicked.bind(this);
    this.onChangeLang = this.onChangeLang.bind(this);
    this.handleDialogOpen = this.handleDialogOpen.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleInstallGuideOpen = this.handleInstallGuideOpen.bind(this);
    this.handleInstallGuideClose = this.handleInstallGuideClose.bind(this);
  }

  componentDidMount() {
    this.loadData();
    // 쿼리 파라미터에서 메시지를 확인
    const params = new URLSearchParams(this.props.location.search);
    const message = params.get("message");
    if (message === "expired") {
      this.setState({ isTokenExpired: true });
    }
  }

  loadData = async () => {
    try {
      const res = await getAPI(API.SYSTEM.BRANCH+'/getList',{useYn:'Y'});
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeCd,
      }));
      // await this.loadComboBoxBrand(_inputData[0].cd);// 브랜드 콤보박스 로딩 (필요하면 주석 해제)
      await this.loadComboBoxMachine(_inputData[0].cd);
      this.setState({ store: _inputData });
    } catch (e) {
      console.error(e.message);
    }
  };

  loadComboBoxMachine = async (storeCd) => {

  };

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  loginClicked= async ()=>{
    try {
      const res = await AuthenticationService.executeJwtAuthenticationService(
        this.state.username,
        this.state.password,
        this.state.branch,
      )
      const data = res.data;
      this.setState({
        token: data.accessToken,
      });
      AuthenticationService.registerSuccessfulLoginForJwt(
        data.username,
        data.accessToken,
        data.branch
      );
      GetLoggedInUserName(this.state.username, this.state.branch).then((response) => {
        localStorage.setItem("userName", response.data.USER_NM);
        localStorage.setItem("group", response.data.GRP_NAME);
        localStorage.setItem("branch", response.data.BRANCH_NAME);
      });
      if (data.daysUntilExpiry){
        alert(data.daysUntilExpiry);
      }
      if (data.initPwdChk === true) {
        this.props.history.push(`/initpwd`);
      } else {
        this.props.history.push(`/main/dashboard`);
      }
    } catch (err) {
      console.error('로그인 실패:', err);
      this.setState({ showSuccessMessage: false });
      this.setState({ hasLoginFailed: true });
    }
  }

  onChangeLang(e) {
    i18next.changeLanguage(e.target.value);
    this.setState({ lang: e.target.value });
  }

  handleDialogOpen() {
    this.setState({ isDialogOpen: true });
  }

  handleDialogClose() {
    this.setState({ isDialogOpen: false });
  }

  handleInstallGuideOpen() {
    this.setState({ isDialogOpen: false, showInstallGuide: true });
  }

  handleInstallGuideClose() {
    this.setState({ showInstallGuide: false });
  }

  render() {
    const { t, classes } = this.props;
    const { isTokenExpired } = this.state;
    const { store } = this.state;

    return (
      <Container sx={styles.container} maxWidth={false}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            position: "relative",
          }}
        >
          <Paper
            variant="elevation"
            elevation={6}
            sx={{
              borderRadius: "20px",
              padding: 2,
              minHeight: "477px",
              minWidth: "400px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* LOGO */}
            <Box
              sx={{
                height: 50,
                backgroundImage: `url(${logo_black})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                mt: "50px",
                mb: "40px",
              }}
            ></Box>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Stack direction="column" sx={{ width: "310px" }}>
                {/* 토큰 만료 메시지 알림 */}
                {isTokenExpired && (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    {t("사용자 인증이 만료되었습니다.")} <br />
                    {t("다시 로그인해주세요.")}
                  </Alert>
                )}
                <FormControl size="small">
                  <Select
                    value={this.state.branch}
                    onChange={this.handleChange}
                    name="branch"
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                  <MenuItem value="">
                    <em>Select Your Key</em>
                  </MenuItem>
                  {store.map((item) => (
                    <MenuItem key={item.cd} value={item.cd}>{item.name}</MenuItem>
                  ))}
                  </Select>
                </FormControl>
                <TextField
                  sx={{ p: 0, m: 0 }}
                  margin="normal"
                  required
                  fullWidth
                  autoFocus
                  placeholder={t("아이디")}
                  name="username"
                  value={this.state.username}
                  onChange={this.handleChange}
                  className={classes.textBox}
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ marginRight: "10px", mt: "5px" }}>
                        <img src={icon_ID} alt="" />
                      </Box>
                    ),
                  }}
                />
                <TextField
                  sx={{ p: 0, mt: 0 }}
                  margin="normal"
                  type="password"
                  required
                  fullWidth
                  autoComplete="current-password"
                  placeholder={t("비밀번호")}
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") this.loginClicked();
                  }}
                  className={classes.textBox2}
                  InputProps={{
                    startAdornment: (
                      <Box sx={{ marginRight: "10px", mt: "5px" }}>
                        <img src={icon_PW} alt="" />
                      </Box>
                    ),
                  }}
                />
                {!this.state.hasLoginFailed && (
                  <Stack
                    sx={{ mt: "10px", mb: "10px" }}
                    direction="row"
                    alignItems="center"
                  >
                    <div style={{ height: "68px" }}></div>
                  </Stack>
                )}
                {this.state.hasLoginFailed && (
                  <Stack
                    sx={{ mt: "10px", mb: "10px", width: "100%" }}
                    spacing={2}
                  >
                    <Alert severity="error">
                      {t("사원정보가 일치하지 않습니다.")}
                      <br />
                      {t("사원정보를 확인해주세요.")}
                    </Alert>
                  </Stack>
                )}

                <ColorButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mb: "10px", height: 48 }}
                  onClick={this.loginClicked}
                >
                  Login
                </ColorButton>
                <FormControl sx={{ height: 40 }} size="small">
                  <Select
                    value={this.state.lang}
                    onChange={this.onChangeLang}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Language</em>
                    </MenuItem>
                    <MenuItem value="en">English</MenuItem>
                    <MenuItem value="ko">Korean</MenuItem>
                  </Select>
                </FormControl>

                {/* "인증서 다운로드" 모달 트리거 버튼 */}
                <Button
                  onClick={this.handleDialogOpen}
                  sx={{ mt: "20px" }}
                  variant="text"
                >
                  <span style={{ color: "blue", fontSize: "10px" }}>{t("인증서 다운로드")}</span>
                </Button>

                {/* 인증서 다운로드 모달 */}
                <Dialog
                  open={this.state.isDialogOpen}
                  onClose={this.handleDialogClose}
                >
                  <DialogTitle>{t("인증서 다운로드")}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {t("모든 기능이 정상적으로 작동하려면 인증서를 설치해야 합니다.")}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleDialogClose} color="primary">
                      {t("닫기")}
                    </Button>
                    <Button
                      href="rootCA.crt" // 실제 URL로 변경 필요
                      color="primary"
                      variant="contained"
                      download
                      onClick={this.handleInstallGuideOpen} // 다운로드 후 설치 안내 모달 열기
                    >
                      {t("다운로드")}
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* 인증서 설치 방법 안내 모달 */}
                <Dialog
                  open={this.state.showInstallGuide}
                  onClose={this.handleInstallGuideClose}
                  maxWidth="md" // 모달 크기 조정
                  fullWidth
                >
                  <DialogTitle>{t("인증서 설치 가이드")}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {/* 인증서 설치 방법 안내 내용 */}
                      {t("인증서를 다운로드한 후 다음 단계를 따라 설치해 주세요:")}
                      <ol>
                        <li>{t("다운로드한 파일을 더블 클릭하여 설치 마법사를 실행합니다.")}</li>
                        <li>{t("화면의 지시에 따라 인증서를 설치합니다.")}</li>
                        <li>{t("설치 과정 중 '모든 인증서를 다음 저장소에 저장'을 선택한 후, '찾아보기' 버튼을 클릭합니다.")}</li>
                        <li>{t("팝업 창에서 '신뢰할 수 있는 루트 인증 기관'을 선택합니다.")}</li>
                        <li>{t("설치가 완료되면, 인증서가 브라우저 또는 운영 체제의 인증서 저장소에 추가됩니다.")}</li>
                      </ol>
                      {t("설치 후에는 브라우저를 재시작해야 합니다.")}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleInstallGuideClose} color="primary">
                      {t("닫기")}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Stack>
            </Stack>
          </Paper>
        </Box>
      </Container>
    );
  }
}

export default withStyles(styless)(withTranslation()(LoginPage));
